<template>
  <div>
    <a class="h-10 px-10 mr-4 text-blue-600 bg-white border border-blue-600 border-solid btn-blue" @click="showing = true">Add Part</a>
    <card-modal :showing="showing" class="px-4 py-2" @close="showing = false">
      <div class="flex">
        <h2 class="flex-auto text-3xl font-bold">Add Part</h2>
        <div class="flex items-center">
          <div class="flex w-full bg-white shadow">
            <input v-model="search" class="relative w-full px-6 py-2 focus:shadow-outline" autocomplete="off" type="text" name="search" placeholder="Search Part" />
          </div>
          <button class="ml-3 text-sm text-gray-500 hover:text-gray-700 focus:text-blue-500" type="button" @click="search = ''">Reset</button>
        </div>
      </div>
      <div class="mt-6">
        <div class="pr-2 overflow-y-scroll max-h-96">
          <table class="w-full">
            <thead>
              <tr class="text-lg font-bold text-left text-center">
                <th class="pt-2 pr-2">Select</th>
                <th class="pt-2 pr-4">Part</th>
                <th class="pt-2 pr-4">Description</th>
                <th class="pt-2">Length</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(part, index) in filteredParts" :key="index"
                class="hover:bg-gray-200 focus-within:bg-gray-300"
                :class="index % 2 == 0 ? '' : 'bg-gray-100'"
              >
                <td class="text-center"><input v-model="selected" type="checkbox" :value="part" /></td>
                <td class="p-2">{{ part.part_number }}</td>
                <td class="">{{ part.description }}</td>
                <td class="text-center">{{ part.length }}</td>
              </tr>
              <tr v-if="parts.length == 0">
                <td class="px-6 py-4 text-xl text-center border-t" colspan="6">No parts found for this configuration.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="flex items-center justify-between mt-6">
          <div class="">Total <span class="p-1 bg-gray-200 rounded-full">{{ filteredParts.length }}</span></div>
          <button class="px-6 btn-blue" @click.stop="add()">Add</button>
        </div>
      </div>
    </card-modal>
  </div>
</template>

<script>
import CardModal from '@/Shared/CardModal'

export default {
  components: {
    CardModal,
  },
  props:{
    parts: Array,
  },
  emits:['input'],
  data() {
    return {
      search  : '',
      selected: [],
      showing : false,
    }
  },
  computed: {
    filteredParts() {
      return this.parts.filter(el => {
        let search  = this.search.toLowerCase()

        let { part_number, description } = el
        part_number = part_number.toLowerCase()
        description = description.toLowerCase()

        return part_number.indexOf(search) > -1 || description.indexOf(search) > -1
      })
    },
  },
  methods: {
    add() {
      this.$emit('input', this.selected)
      this.showing  = false
      this.selected = []
    },
  },
}
</script>
